import { IconX } from "@tabler/icons-react";
import { twMerge } from "tailwind-merge";

export const PopUp: React.FC<{
	children: React.ReactNode;
	className?: string;
	isOpen: boolean;
	setIsOpen?: React.Dispatch<boolean>;
}> = ({ children, className, isOpen, setIsOpen }) => {
	return (
		<>
			{isOpen && (
				<div
					className="z-20 h-screen w-full backdrop-blur-sm bg-[#c6c6c621] fixed top-0 left-0 flex items-center justify-center"
					onClick={() => (setIsOpen ? setIsOpen(false) : true)}
				>
					<div
						className={twMerge(
							`max-w-[90%] h-fit w-fit max-h-[93%] p-12 bg-[#ffffff] rounded-2xl overflow-y-auto shadow-md relative`,
							className,
						)}
						onClick={(e) => e.stopPropagation()}
					>
						{setIsOpen && (
							<button
								className="absolute top-4 right-4"
								onClick={() => setIsOpen(false)}
							>
								<IconX
									width={32}
									height={32}
									stroke={2}
									color="grey"
								/>
							</button>
						)}
						{children}
					</div>
				</div>
			)}
		</>
	);
};
